<template>
    <div id="app"
         v-cloak>
        <router-view />
    </div>
</template>


<script>
export default {
    name: 'app',
    data () {
        return {
            loadTime: '',
        }
    },
    mounted () {
        // window.addEventListener('beforeunload', e => this.beforeunloadFn())
        // window.addEventListener('unload', e => this.unloadFn())
    },
    methods: {
        unloadFn () {
            let gapTtime = new Date().getTime() - this.loadTime
            let whiteList = [
                'print_cost',
                'print_report',
                'approve_print',
                'print_formDetail',
                'print_sku_cost',
                'storage',
                'purchasing_manage',
                'output_plan',
                'put_in_storage',
                'qualityTesting',
                'purchasing_single',
                'outbound',
                'fba_outbound'
            ]
            for (let index in whiteList) {
                if (location.href.includes(whiteList[index])) {
                    return
                }
            }
            if (gapTtime <= 2) {
                // localStorage.clear()
                Object.keys(localStorage).forEach(item => {
                    if (item.indexOf('token') !== -1 || item.indexOf('LogOut') !== -1) {
                        localStorage.removeItem(item)
                    }
                })
            }
        },
        beforeunloadFn () {
            this.loadTime = new Date().getTime()
        },
    },
    destroyed () {
        window.removeEventListener('beforeunload', e => this.beforeunloadFn())
        window.removeEventListener('unload', e => this.unloadFn())
    }
}
</script>
<style lang="less">
@import "./assets/font/iconfont.css";
@import "./assets/css/reset.css";
@import "./assets/css/changeElement.css";
.red {
    color: red;
}
#app {
    width: 100%;
    height: 100%;
    // .el-button--primary {
    //     background-color: #006eff;
    //     border-color: #006eff;
    //     color: #fff;
    // }
}
.el-table__body-wrapper::-webkit-scrollbar {
    background: #ebeef5;
    width: 10px; // 横向滚动条
    height: 10px; // 纵向滚动条
}

.el-table__body-wrapper::-webkit-scrollbar-track {
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 3px; /*滚动条的背景区域的圆角*/
    -webkit-transition: background-color 0.3s;
    transition: background-color 0.3s;
    background-color: #eee;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 3px; /*滚动条的圆角*/
    background-color: rgba(0, 0, 0, 0.4);
}
.el-table__fixed-footer-wrapper tbody td {
    border-top: none !important;
}
</style>
